import api from 'services/api';
import { thirdPartyServicesRemovePath } from 'constants/endpointsPath/thirdPartyServices';

const RemoveThirdPartyServices = async (serviceId: string): Promise<void> => {
  const path = thirdPartyServicesRemovePath(serviceId);
  await api.delete(path);
};

export default RemoveThirdPartyServices;
